import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MntInvoicesModule } from '../../mnt-invoices/mnt-invoices.module';
import { PublicQuoteRoutingModule } from './public-quote-routing.module';

@NgModule({
  imports: [
    CommonModule,
    PublicQuoteRoutingModule,
    MntInvoicesModule
  ]
})
export class PublicQuoteModule { }


// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/public-quote/public-quote.module.ts